declare global {
  interface HTMLElement {
    clickOutsideEvent?: (event: MouseEvent) => void;
  }
}

import { DirectiveOptions } from 'vue'

const clickOutside: DirectiveOptions = {
  bind(el, binding) {
    el.clickOutsideEvent = (event: MouseEvent) => {
      const toggleButton = document.querySelector('.user-avatar-btn') // or use a ref
      if (
        !(el === event.target || el.contains(event.target as Node)) &&
        !(toggleButton && toggleButton.contains(event.target as Node))
      ) {
        binding.value(event)
      }
    }
    document.addEventListener('click', el.clickOutsideEvent)
  },
  unbind(el) {
    document.removeEventListener('click', el.clickOutsideEvent!)
  },
}

export default clickOutside
